module.exports = __webpack_public_path__ + "static/media/AccordLoader.17246fda.gif";